class ImgUrl {
  static getIconUrlWithSize(baseUrl: string, size: string | number) {
    if (baseUrl) {
      return baseUrl + '/' + size
    }
    return null
  }
}

export default ImgUrl
